import { PlusIcon } from "lucide-react";

import { trpc } from "@blis/trpc/react";

import { Link } from "@/components/Link";
import { usePersistedAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TableFilterRow } from "../TableFilterRow";

export function FieldSetsTable() {
  const { data } = trpc.admin.sampleFieldSet.list.useQuery();

  const fieldSets = data ?? [];

  const { options, filterTextProps } = usePersistedAdminGridOptions(
    "fieldSets",
    fieldSets,
    [
      {
        field: "name",
        headerName: "Field set",
        cellRenderer: (params) => (
          <Link
            to="/admin/tubes/field-sets/$id/edit"
            params={{ id: params.id }}
          >
            {params.name}
          </Link>
        ),
        cellRendererParams: (params) => ({
          name: params.data.name,
          id: params.data.id,
        }),
      },
    ],
    { sideBar: undefined },
  );

  return (
    <>
      <TableFilterRow inputProps={filterTextProps}>
        <Link to="/admin/tubes/field-sets/new" asButton>
          <PlusIcon data-slot="icon" />
          Add field set
        </Link>
      </TableFilterRow>
      <AdminGrid {...options} />
    </>
  );
}
